import PasswordResetSuccessView from './PasswordResetSuccess';

export default PasswordResetSuccessView;
